
export const tr = {
  nav: {
    home: 'Ana Sayfa',
    about: 'Hakkımızda',
    services: 'Hizmetler',
    blog: 'Blog',
    contact: 'İletişim',
    language: 'Dil'
  },
  header: {
    search: 'Arama yapın...',
    login: 'Giriş Yap',
    register: 'Üye Ol',
    logout: 'Çıkış Yap',
    account: 'Hesap'
  },
  auth: {
    login: 'Giriş Yap',
    register: 'Üye Ol',
    fullName: 'Ad Soyad',
    email: 'E-posta',
    password: 'Şifre',
    confirmPassword: 'Şifre Tekrar',
    enterFullName: 'Ad soyadınızı girin',
    enterEmail: 'E-posta adresinizi girin',
    enterPassword: 'Şifrenizi girin',
    confirmPasswordPlaceholder: 'Şifrenizi tekrar girin',
    loginButton: 'Giriş Yap',
    registerButton: 'Üye Ol',
    processing: 'İşleniyor...',
    noAccount: 'Hesabınız yok mu?',
    hasAccount: 'Zaten hesabınız var mı?',
    loginLink: 'Giriş yapın',
    registerLink: 'Üye olun',
    passwordMismatch: 'Şifreler eşleşmiyor',
    passwordTooShort: 'Şifre en az 6 karakter olmalıdır',
    invalidCredentials: 'Geçersiz e-posta veya şifre',
    emailExists: 'Bu e-posta adresi zaten kullanılıyor',
    generalError: 'Bir hata oluştu, lütfen tekrar deneyin'
  },
  hero: {
    title: 'Profesyonel Sertifikalarla Kariyerinizi İleriye Taşıyın',
    subtitle: 'IQCERT ile uluslararası geçerliliğe sahip sertifikalar alın ve iş dünyasında fark yaratın. Uzman eğitmenlerimiz ve kaliteli eğitim programlarımızla başarıya ulaşın.',
    cta: 'Sertifikalara Göz At',
    watchVideo: 'Tanıtım Videosunu İzle'
  },

  // Navigation
  "nav.home": "Ana Sayfa",
  "nav.about": "Hakkımızda",
  "nav.services": "Hizmetler",
  "nav.blog": "Blog",
  "nav.contact": "İletişim",
  "nav.language": "Dil",

  // Hero Section
  "hero.title": "Profesyonel Sertifika Eğitimleri",
  "hero.subtitle": "Kariyerinizi ilerletmek için ihtiyacınız olan sertifikaları alın",
  "hero.description": "Uzman eğitmenlerden online sertifika programları ile becerilerinizi geliştirin ve kariyerinizde fark yaratın.",
  "hero.cta": "Eğitimleri Keşfet",
  "hero.watch": "Tanıtım Videosunu İzle",

  // Services Section
  "services.title": "Sertifika Programları",
  "services.subtitle": "Alanında uzman eğitmenlerden kaliteli eğitimler",
  "services.it.title": "Bilişim Teknolojileri",
  "services.it.description": "Yazılım geliştirme, veri analizi ve siber güvenlik alanlarında profesyonel sertifika programları.",
  "services.business.title": "İş Yönetimi",
  "services.business.description": "Proje yönetimi, liderlik ve iş geliştirme konularında uzman eğitmenlerden sertifika programları.",
  "services.design.title": "Tasarım ve Yaratıcılık",
  "services.design.description": "Grafik tasarım, UI/UX ve dijital pazarlama alanlarında yaratıcı sertifika programları.",
  "services.language.title": "Dil Eğitimleri",
  "services.language.description": "İngilizce, Almanca ve diğer yabancı dillerde uluslararası geçerlilikte sertifika programları.",

  // Blog Section
  "blog.title": "Son Yazılar",
  "blog.subtitle": "Eğitim ve kariyer gelişimi hakkında güncel içerikler",
  "blog.readMore": "Devamını Oku",
  "blog.post1.title": "Dijital Çağda Sertifika Eğitimlerinin Önemi",
  "blog.post1.excerpt": "Teknolojinin hızla geliştiği günümüzde, sürekli öğrenme ve kendini geliştirme artık bir lüks değil, zorunluluk haline geldi.",
  "blog.post1.author": "Dr. Mehmet Yılmaz",
  "blog.post1.date": "15 Aralık 2024",
  "blog.post1.category": "Eğitim",
  "blog.post2.title": "Kariyer Gelişiminde Sertifikaların Rolü",
  "blog.post2.excerpt": "İş dünyasında öne çıkmak için hangi sertifikaları almalısınız? Uzmanlardan tavsiyeler ve başarı hikayeleri.",
  "blog.post2.author": "Ayşe Demir",
  "blog.post2.date": "12 Aralık 2024",
  "blog.post2.category": "Kariyer",
  "blog.post3.title": "Online Eğitimde Başarı İçin 10 İpucu",
  "blog.post3.excerpt": "Online eğitimlerden maksimum verim almak için uygulamanız gereken stratejiler ve öneriler.",
  "blog.post3.author": "Prof. Dr. Ali Kaya",
  "blog.post3.date": "10 Aralık 2024",
  "blog.post3.category": "İpuçları",

  // About Section
  "about.title": "Neden Bizi Seçmelisiniz?",
  "about.subtitle": "10 yılı aşkın deneyimimizle binlerce öğrenciye sertifika kazandırdık",
  "about.expert.title": "Uzman Eğitmenler",
  "about.expert.description": "Alanında deneyimli ve sertifikalı eğitmenlerden kaliteli eğitim alın",
  "about.flexible.title": "Esnek Eğitim",
  "about.flexible.description": "Kendi hızınızda, istediğiniz zaman ve yerden eğitime katılın",
  "about.certificate.title": "Geçerli Sertifikalar",
  "about.certificate.description": "Uluslararası geçerliliği olan sertifikalarla kariyerinizi güçlendirin",
  "about.support.title": "7/24 Destek",
  "about.support.description": "Eğitim sürecinizde her zaman yanınızdayız",
  "about.tagline": "IQCERT Belgelendirme",
  "about.certificates.badge": "Uluslararası Geçerli Sertifikalar",
  "about.certificates.badgeDesc": "ISO 9001, ISO 14001, HACCP, SCC ve daha fazlası",

  // Blog Section
  "blog.title": "Son Yazılar",
  "blog.subtitle": "Eğitim ve kariyer gelişimi hakkında güncel içerikler",
  "blog.readMore": "Devamını Oku",

  // News Section
  "news.title": "Haberler & Duyurular",
  "news.subtitle": "Sektörden son haberler ve önemli duyurular",

  // Info Banners
  "info.students": "Aktif Öğrenci",
  "info.courses": "Sertifika Programı",
  "info.instructors": "Uzman Eğitmen",
  "info.satisfaction": "Memnuniyet Oranı",

  // Footer
  "footer.description": "Profesyonel sertifika eğitimleri ile kariyerinizi ileriye taşıyın",
  "footer.quickLinks": "Hızlı Bağlantılar",
  "footer.programs": "Programlar",
  "footer.support": "Destek",
  "footer.contact": "İletişim",
  "footer.phone": "Telefon",
  "footer.email": "E-posta",
  "footer.address": "Adres",
  "footer.rights": "Tüm hakları saklıdır",

  // Common
  "common.learnMore": "Daha Fazla Bilgi",
  "common.getStarted": "Başla",
  "common.viewAll": "Tümünü Gör",
  "common.loading": "Yükleniyor...",
  "common.error": "Bir hata oluştu",
  "common.success": "Başarılı",

  // Services Pages
  "services.belgelendirme.title": "Belgelendirme Hizmetleri",
  "services.belgelendirme.subtitle": "Sürdürülebilir Turizm, GSTC Sertifikası, Personel ve Vegan Belgelendirme",
  "services.belgelendirme.description": "IQCERT olarak, farklı sektörlerde uluslararası standartlara uygun belgelendirme hizmetleri sunuyoruz. Sürdürülebilir turizm, personel yetkinlikleri ve özel belgelendirme alanlarında uzman ekibimizle hizmet veriyoruz.",
  "services.belgelendirme.sustainable": "Sürdürülebilir Turizm",
  "services.belgelendirme.gstc": "GSTC Sertifikası",
  "services.belgelendirme.personnel": "Personel Belgelendirme",
  "services.belgelendirme.vegan": "Vegan Belgelendirme",

  "services.yonetim.title": "Yönetim Sistemleri Belgelendirme",
  "services.yonetim.subtitle": "ISO Standartları ve Yönetim Sistemleri Belgelendirme Hizmetleri",
  "services.yonetim.description": "Kalite, çevre, iş sağlığı ve güvenliği, enerji yönetimi gibi alanlarda ISO standartlarına uygun belgelendirme hizmetleri sunuyoruz.",
  "services.yonetim.iso9001": "ISO 9001 Kalite Yönetim Sistemi",
  "services.yonetim.iso14001": "ISO 14001 Çevre Yönetim Sistemi",
  "services.yonetim.iso45001": "ISO 45001 İş Sağlığı ve Güvenliği",
  "services.yonetim.iso50001": "ISO 50001 Enerji Yönetim Sistemi",
  "services.yonetim.iso10002": "ISO 10002 Müşteri Memnuniyeti Yönetimi",
  "services.yonetim.iso27001": "ISO 27001 Bilgi Güvenliği Yönetimi",
  "services.yonetim.iso27701": "ISO 27701 Kişisel Verilerin Güvenliği",
  "services.yonetim.iso31000": "ISO 31000 Risk Yönetim Sistemi",
  "services.yonetim.iso39001": "ISO 39001 Karayolu Trafik Güvenliği",
  "services.yonetim.iso28001": "ISO 28001 Tedarik Zinciri Güvenliği",
  "services.yonetim.iso22301": "ISO 22301 İş Sürekliliği Yönetimi",

  // ISO Standards Details
  "iso.9001.description": "Müşteri memnuniyetini artıran kalite yönetim sistemi standardı",
  "iso.9001.benefits.1": "Müşteri memnuniyeti artışı",
  "iso.9001.benefits.2": "Süreç verimliliği",
  "iso.9001.benefits.3": "Hata oranlarında azalma",
  "iso.9001.benefits.4": "Sürekli iyileştirme kültürü",

  "iso.14001.description": "Çevresel etkileri minimize eden yönetim sistemi",
  "iso.14001.benefits.1": "Çevresel risk azaltma",
  "iso.14001.benefits.2": "Enerji tasarrufu",
  "iso.14001.benefits.3": "Atık yönetimi",
  "iso.14001.benefits.4": "Yasal uyumluluk",

  "iso.45001.description": "Çalışan sağlığı ve güvenliğini koruma sistemi",
  "iso.45001.benefits.1": "İş kazalarında azalma",
  "iso.45001.benefits.2": "Çalışan güvenliği",
  "iso.45001.benefits.3": "Risk değerlendirmesi",
  "iso.45001.benefits.4": "Yasal yükümlülük karşılama",

  "iso.50001.description": "Enerji verimliliğini artıran yönetim sistemi",
  "iso.50001.benefits.1": "Enerji maliyetlerinde azalma",
  "iso.50001.benefits.2": "Karbon ayak izi azaltma",
  "iso.50001.benefits.3": "Enerji performansı iyileştirme",
  "iso.50001.benefits.4": "Sürdürülebilirlik",

  "iso.10002.description": "Müşteri şikayetlerini etkin yönetme sistemi",
  "iso.10002.benefits.1": "Müşteri sadakati artışı",
  "iso.10002.benefits.2": "Şikayet çözüm süreci",
  "iso.10002.benefits.3": "Müşteri geri bildirimi",
  "iso.10002.benefits.4": "Hizmet kalitesi iyileştirme",

  "iso.27001.description": "Bilgi varlıklarını koruma ve güvenlik yönetimi",
  "iso.27001.benefits.1": "Veri güvenliği",
  "iso.27001.benefits.2": "Siber saldırı korunması",
  "iso.27001.benefits.3": "Gizlilik sağlama",
  "iso.27001.benefits.4": "Yasal uyumluluk",

  "iso.27701.description": "KVKK ve GDPR uyumlu kişisel veri koruma sistemi",
  "iso.27701.benefits.1": "KVKK uyumluluğu",
  "iso.27701.benefits.2": "Kişisel veri güvenliği",
  "iso.27701.benefits.3": "Gizlilik yönetimi",
  "iso.27701.benefits.4": "Yasal risk azaltma",

  "iso.31000.description": "Kurumsal riskleri sistematik yönetme",
  "iso.31000.benefits.1": "Risk tanımlama",
  "iso.31000.benefits.2": "Risk değerlendirmesi",
  "iso.31000.benefits.3": "Risk azaltma stratejileri",
  "iso.31000.benefits.4": "Karar verme süreçleri",

  "iso.39001.description": "Trafik güvenliğini artıran yönetim sistemi",
  "iso.39001.benefits.1": "Trafik kazalarında azalma",
  "iso.39001.benefits.2": "Sürücü güvenliği",
  "iso.39001.benefits.3": "Araç filosu yönetimi",
  "iso.39001.benefits.4": "Güvenlik kültürü",

  "iso.28001.description": "Tedarik zinciri güvenlik yönetim sistemi",
  "iso.28001.benefits.1": "Tedarik güvenliği",
  "iso.28001.benefits.2": "Lojistik güvenlik",
  "iso.28001.benefits.3": "Risk yönetimi",
  "iso.28001.benefits.4": "Operasyonel süreklilik",

  "iso.22301.description": "İş sürekliliğini sağlayan yönetim sistemi",
  "iso.22301.benefits.1": "İş sürekliliği planlaması",
  "iso.22301.benefits.2": "Kriz yönetimi",
  "iso.22301.benefits.3": "Operasyonel dayanıklılık",
  "iso.22301.benefits.4": "Hızlı toparlanma",

  // Implementation Process
  "implementation.title": "Uygulama Süreci",
  "implementation.subtitle": "Sistematik yaklaşımımızla yönetim sistemlerinizi başarıyla uyguluyoruz",
  "implementation.step1.title": "Mevcut Durum Analizi",
  "implementation.step1.description": "Organizasyonun mevcut durumunun değerlendirilmesi ve gap analizi",
  "implementation.step2.title": "Sistem Tasarımı",
  "implementation.step2.description": "ISO standardına uygun yönetim sisteminin tasarlanması",
  "implementation.step3.title": "Dokümantasyon",
  "implementation.step3.description": "Politika, prosedür ve talimatların hazırlanması",
  "implementation.step4.title": "Eğitim ve Uygulama",
  "implementation.step4.description": "Personel eğitimi ve sistemin uygulamaya konulması",
  "implementation.step5.title": "İç Denetim",
  "implementation.step5.description": "Sistemin etkinliğinin iç denetimlerle kontrolü",
  "implementation.step6.title": "Belgelendirme Denetimi",
  "implementation.step6.description": "Bağımsız kuruluş tarafından sertifikasyon denetimi",

  // Why Choose ISO
  "why.iso.title": "Neden ISO Yönetim Sistemleri?",
  "why.iso.subtitle": "ISO standartları ile organizasyonunuzun performansını artırın",
  "why.iso.recognition.title": "Uluslararası Tanınırlık",
  "why.iso.recognition.description": "Global pazarlarda geçerli sertifikasyon",
  "why.iso.improvement.title": "Süreç İyileştirme",
  "why.iso.improvement.description": "Operasyonel verimlilikte artış",
  "why.iso.risk.title": "Risk Yönetimi",
  "why.iso.risk.description": "Proaktif risk tanımlama ve yönetimi",
  "why.iso.trust.title": "Müşteri Güveni",
  "why.iso.trust.description": "Artan müşteri memnuniyeti ve sadakati",

  // CTA Section
  "cta.iso.title": "ISO Yönetim Sistemi Kurulumuna Başlayın",
  "cta.iso.description": "Uzman danışmanlarımız size en uygun ISO standardını belirlemenize ve başarılı bir şekilde uygulamanıza yardımcı olur.",
  "cta.consultation": "Ücretsiz Danışmanlık",
  "cta.quote": "Teklif Al",

  // General
  "iso.standards.title": "ISO Yönetim Sistemleri",
  "iso.standards.subtitle": "Uluslararası standartlarda yönetim sistemleri ile işletmenizi geleceğe hazırlayın",
  "benefits.title": "Faydaları:",

  "services.teknik.title": "Teknik Kontroller",
  "services.teknik.subtitle": "Asansör, yürüyen merdiven ve teknik ekipman kontrolleri",
  "services.teknik.description": "Teknik ekipmanların güvenli çalışması için periyodik kontrol ve muayene hizmetleri sunuyoruz.",
  "services.teknik.elevator": "Asansör Periyodik Kontrolü",
  "services.teknik.escalator": "Yürüyen Merdiven Periyodik Kontrolü",
  "services.teknik.photovoltaic": "Fotovoltaik Kontrolleri",
  "services.teknik.equipment": "İş Ekipmanları Kontrolleri",

  "services.denetim.title": "Denetim ve Gözetim Hizmetleri",
  "services.denetim.subtitle": "Yükleme öncesi gözetim, ikinci taraf denetim ve hijyen kontrolleri",
  "services.denetim.description": "Ürün kalitesi ve süreç güvenliği için kapsamlı denetim ve gözetim hizmetleri sunuyoruz.",
  "services.denetim.preloading": "Yükleme Öncesi Gözetimler",
  "services.denetim.secondparty": "İkinci Taraf Denetim",
  "services.denetim.hygiene": "Hijyen ve Sanitasyon",

  "services.enerji.title": "Enerji Verimliliği",
  "services.enerji.subtitle": "Enerji kimlik belgesi, etüd ve danışmanlık hizmetleri",
  "services.enerji.description": "Enerji tasarrufu ve verimliliği konularında uzman danışmanlık ve belgelendirme hizmetleri sunuyoruz.",
  "services.enerji.certificate": "Enerji Kimlik Belgesi",
  "services.enerji.study": "Enerji Etüdü",
  "services.enerji.consulting": "Enerji Verimliliği Danışmanlığı",
  "services.enerji.zerowaste": "Sıfır Atık Süreç Yönetimi",

  "services.ozel.title": "Özel Denetimler",
  "services.ozel.subtitle": "Okul, yeşil bina, otel ve spor güvenliği denetimleri",
  "services.ozel.description": "Özel sektörlere yönelik güvenlik ve kalite denetim hizmetleri sunuyoruz.",
  "services.ozel.school": "Okul Güvenliği",
  "services.ozel.green": "Yeşil Bina",
  "services.ozel.hotel": "Otel Denetimleri",
  "services.ozel.sports": "Spor Güvenliği",

  // Certificate Showcase
  "showcase.badge": "Uluslararası Sertifikalar",
  "showcase.title": "Dünyaca Tanınan Belgelendirme Standartları",
  "showcase.description": "GMP, HACCP, ISO ve daha fazlasını kapsayan uluslararası geçerliliğe sahip sertifikalarımızla işletmenizi küresel standartlara taşıyın.",
  "showcase.point1": "ISO 9001, ISO 14001, ISO 45001 ve daha fazlası",
  "showcase.point2": "HACCP, GMP gıda güvenliği belgelendirmesi",
  "showcase.point3": "SCC, GSTC uluslararası sertifikalar",
  "showcase.point4": "Hızlı ve güvenilir belgelendirme süreci",

  // Achievement Section
  "achievement.badge": "Kurumsal Başarılar",
  "achievement.title": "Uluslararası Tanınırlık ve Başarı",
  "achievement.subtitle": "IQ CERT olarak uluslararası arenada elde ettiğimiz başarılar ve akreditasyonlarla sektörde güvenilir bir referans noktasıyız.",
  "achievement.caption": "IQ PCC-PYB Sertifika Töreni",
  "achievement.description": "Uluslararası akreditasyon kuruluşları tarafından onaylanan belgelendirme yetkinliğimiz, müşterilerimize en yüksek kalite güvencesini sunmamızı sağlamaktadır.",
  "achievement.caption2": "Zengezur Üniversitesi Sertifika Töreni",
  "achievement.description2": "Uluslararası iş birliklerimiz kapsamında gerçekleştirilen sertifika töreninde, katılımcılara IQ CERT tarafından onaylanan belgeler takdim edildi.",
  "achievement.caption3": "ULAK İş Birliği ve Çözüm Ortaklığı",
  "achievement.description3": "ULAK Genel Başkanı Fatih Sinan Yılmaz ile gerçekleştirdiğimiz stratejik iş birliği kapsamında, uluslararası akreditasyon standartlarında hizmet kalitemizi artırıyoruz.",
  "achievement.stat1": "Ülkede Geçerlilik",
  "achievement.stat2": "Verilen Sertifika",
  "achievement.stat3": "Yıllık Deneyim",
  "achievement.stat4": "Müşteri Memnuniyeti"
};

export default tr;
